export default __webpack_public_path__ + "static/Asif_Seemab-92496c092ad26e61aaee095b03fff7bd.jpg";